import { JsonParam, StringParam } from 'use-query-params';

import { encodeQueryParamsUsingSchema } from 'utils/useEncodedFilters/helpers';

export const getUploadsDashboardLocation = ({ labId, studyId }: { labId?: string; studyId: string }) => ({
  pathname: '/uploads-dashboard',
  search: encodeQueryParamsUsingSchema(
    {
      filters: { studyId },
      labId: labId || '',
    },
    {
      filters: JsonParam,
      labId: StringParam,
    }
  ),
});
